<template>
    <div>
        <v-container fluid v-if="!successPage">
            <v-row justify="center">
                <v-flex xs6 sm4 md2 lg1 mt-2>
                    <router-link to="/youtv/"><v-img :transition="false" src="/img/youtv_logo.png"></v-img></router-link>
                </v-flex>
            </v-row>
            <v-layout align-center justify-center>
                <v-flex xs12 sm12 md6 lg5>
                    <ValidationObserver ref="obs" v-slot="{ invalid, validated, passes, validate }">
                        <material-card class="text-center title font-weight-bold" color="youtv" title="Покупка пакету You TV">
                            <v-card-text>
                                <v-alert type="warning" color="black" v-if="alertMessage">
                                    {{alertMessage}}
                                </v-alert>
                                <p class="body-1">Пакет: <span class="font-weight-bold red--text headline">«{{serviceName}}»</span></p>
                                <p class="body-1">Цiна пакету: <span class="font-weight-bold red--text headline">{{servicePrice}} грн.</span></p>
                                <v-alert type="warning">
                                    Звертаємо увагу, що предметом покупки є Код активації пакету You TV.<br>Отриманий Код не може бути повернутий після придбання.
                                </v-alert>
                                <p class="body-1 font-weight-bold mt-8 text-left">Адреса Торгової точки, з якої здійснюється продаж:</p>
                                <v-radio-group v-model="f.shopId" mandatory>
                                    <v-radio :value="e.id" :label="e.address+ ', ' + e.name" v-for="(e, i) in shops" :key="i" color="cardheaderdark"></v-radio>
                                </v-radio-group>
                                <p class="body-1 font-weight-bold mt-4 text-left">Підтвердження покупки:</p>
                                <v-progress-linear indeterminate class="ma-0" height="3" :active="loading" color="error"></v-progress-linear>
                                <v-alert type="error" outlined v-if="errorMessage">
                                    {{errorMessage}}
                                </v-alert>
                                <validation-provider v-slot="{ errors, valid }" rules="required|tel">
                                    <v-text-field v-show="!codeCheck" :success="valid" persistent-hint hint="Введіть номер телефону покупця для отримання SMS-коду підтвердження" prepend-icon="mdi-phone" name="phone" label="Телефон покупця" placeholder="+38(000) 000 - 0000" v-mask="maskTel" v-model="f.phone"></v-text-field>
                                </validation-provider>
                                <validation-provider v-if="codeCheck" v-slot="{ errors, valid }" rules="required|length:5">
                                    <v-text-field v-show="codeCheck" :success="valid" persistent-hint hint="Введiть SMS-код підтвердження" prepend-icon="mdi-cellphone-text" name="code" label="Код SMS" placeholder="00000" v-mask="maskCode" v-model="f.code"></v-text-field>
                                </validation-provider>
                            </v-card-text>
                            <v-card-actions v-if="$vuetify.breakpoint.xsOnly">
                                <v-spacer></v-spacer>
                                <v-btn color="youtv" text @click="passes(submitForm)" :disabled="invalid || !validated"><span v-if="!codeCheck">Відправити код</span><span v-if="codeCheck">Придбати</span></v-btn>
                                <v-spacer></v-spacer>
                            </v-card-actions>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn dark color="blue" text @click="$router.go(-1)">
                                    <v-icon right dark>mdi-keyboard-return</v-icon> Повернутись
                                </v-btn>
                                <v-btn v-if="!$vuetify.breakpoint.xsOnly" color="youtv" text @click="passes(submitForm)" :disabled="invalid || !validated"><span v-if="!codeCheck">Відправити код</span><span v-if="codeCheck">Придбати</span></v-btn>
                                <v-spacer></v-spacer>
                            </v-card-actions>
                        </material-card>
                    </ValidationObserver>
                </v-flex>
            </v-layout>
        </v-container>
    <YoutvSuccessPage v-if="successPage" :phone="this.f.phone" :serviceCODE="this.serviceCODE" :printName="printName" />
</div>
</template>

<script>
import {
    mask
} from 'vue-the-mask'

import {
    ValidationObserver,
    ValidationProvider
} from "vee-validate"

import YoutvSuccessPage from '../components/YoutvSuccessPage.vue'

import {
    mapActions
} from 'vuex'

export default {
    components: {
        ValidationProvider,
        ValidationObserver
    },
    directives: {
        mask
    },
    data() {
        return {
            loading: false,
            maskTel: '+38(###) ###-####',
            maskCode: '#####',
            codeCheck: false,
            successPage: false,
            f: {},
            errorMessage: '',
            alertMessage: '',
            serviceCODE: null,
            shops: []
        }
    },
    methods: {
        ...mapActions(['youtvBuy', 'verifyYoutvBuy','getMyYoutvShops']),
        async submitForm() {
            this.errorMessage = ''
            this.loading = true
            this.f.serviceId = this.$route.params.id
            if (this.f.code) {
                this.verifyYoutvBuy(this.f)
                    .then(d => {
                        this.serviceCODE = d.serviceCODE
                        this.successPage = true
                        this.loading = false
                    })
                    .catch(
                        error => {
                            this.loading = false
                            if (error.response && error.response.status == 403) {
                                this.errorMessage = 'Код не вiрний, або термiн коду збiг!'
                                this.loading = false
                            } else {
                                this.errorMessage = error.response.data.error.message
                            }
                        }
                    )
            } else {
                this.youtvBuy(this.f)
                    .then(
                        d => {
                            this.codeCheck = true
                            this.f.token = d.token
                            this.loading = false
                            if (d.reservedEarlier) {
                                this.alertMessage = 'Завершіть придбання коду You TV, що для вас зарезервовано, або зачекайте поки резерв буде скинуто'
                            }
                        }
                    )
                    .catch(
                        error => {
                            this.loading = false

                            if (error.response && error.response.status == 403) {
                                this.errorMessage = 'Вибачте, але вільних кодів для сервісу вже немає. Оберіть інший сервіс'
                            } else if (error.response && error.response.status == 401) {
                                this.errorMessage = 'Помилка! Спробуйте ще раз!'
                            } else {
                                this.errorMessage = error.response.data.error.message
                            }
                        }
                    )
            }
        }
    },
    created() {
        this.getMyYoutvShops()
            .then(data => {
                this.shops = data || []
        })
    },
    computed: {
        serviceName() {
            const service = this.$store.state.youtv.youtvList.find(el => el.id == this.$route.params.id)
            return service ? service.name : ''
        },
        printName() {
            const service = this.$store.state.youtv.youtvList.find(el => el.id == this.$route.params.id)
            return service ? service.print_name : ''
        },
        servicePrice() {
            const service = this.$store.state.youtv.youtvList.find(el => el.id == this.$route.params.id)
            return service ? service.price : ''
        }
    }
}
</script>

<style>
</style>
